import React from 'react';
import Footer from '../Footer';
import Form from './components/Form';
import FormikHOC from './components/FormHOC';

export default function Status() {
  return (
    <FormikHOC>
      <Form />
      <Footer />
    </FormikHOC>
  );
}
